import { render, staticRenderFns } from "./MessageAccount.vue?vue&type=template&id=108737e8"
import script from "./MessageAccount.vue?vue&type=script&lang=js"
export * from "./MessageAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports